import * as React from 'react';

import {Link} from 'shells/link/link';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function CompletedActionsPage() {
    return (
        <OnboardingBody title='Completed actions' statusText='Engagement report'>
            <p>
                Visitors who completed an activity (e.g. chat, call, email, or quote) will be
                counted here.
            </p>
            <p>
                <em>Example: A visitor submits a quote form through the engagement bar.</em>
            </p>
            <p>
                To get the most out of your chat widget, explore what the {/* @ts-expect-error */}
                <Link href='/inbox/settings/chat' target='_blank'>
                    engagement bar
                </Link>{' '}
                can do.
            </p>
        </OnboardingBody>
    );
}
